import { render, staticRenderFns } from "./RmPartNoMaintain.vue?vue&type=template&id=45554e63&scoped=true"
import script from "./RmPartNoMaintain.vue?vue&type=script&lang=js"
export * from "./RmPartNoMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45554e63",
  null
  
)

export default component.exports